import { useQuery } from '@tanstack/react-query';
import ExerciceService from '../Services/exercices/ExerciceService';

export const GET_EXERCICES_QUERY_KEY = 'getExercices';
export const SHOW_EXERCICE_DETAILS_QUERY_KEY = 'showExerciceDetails';

export const useGetExercices = () => {
  return useQuery({
    queryKey: [GET_EXERCICES_QUERY_KEY],
    queryFn: ExerciceService.listAllExercices,
  });
};

export const useShowExerciceDetails = (id) => {
  return useQuery({
    queryKey: [SHOW_EXERCICE_DETAILS_QUERY_KEY, id],
    queryFn: () => ExerciceService.showExerciceDetails(id),
  });
};